import Card from 'react-bootstrap/Card'
import CardGroup from 'react-bootstrap/CardGroup'
import Button from 'react-bootstrap/Button'
import Form from 'react-bootstrap/Form'
import styles from './AmazonShopItem.module.css'

export default function AmazonShopItem(props) {
  return(
    <div className={styles.container}>
      <div dangerouslySetInnerHTML={{__html: props.code }} className={styles.item}/>
    </div>
  )
}